export const INSTALLLMENTS = [
  { value: 1, label: "À vista" },
  { value: 2, label: "2 parcelas" },
  { value: 3, label: "3 parcelas" },
  { value: 4, label: "4 parcelas" },
  { value: 5, label: "5 parcelas" },
  { value: 6, label: "6 parcelas" },
  { value: 7, label: "7 parcelas" },
  { value: 8, label: "8 parcelas" },
  { value: 9, label: "9 parcelas" },
  { value: 10, label: "10 parcelas" },
  { value: 11, label: "11 parcelas" },
  { value: 12, label: "12 parcelas" },
  { value: 13, label: "13 parcelas" },
  { value: 14, label: "14 parcelas" },
  { value: 15, label: "15 parcelas" },
  { value: 16, label: "16 parcelas" },
  { value: 17, label: "17 parcelas" },
  { value: 18, label: "18 parcelas" },
  { value: 19, label: "19 parcelas" },
  { value: 20, label: "20 parcelas" },
  { value: 21, label: "21 parcelas" },
  { value: 22, label: "22 parcelas" },
  { value: 23, label: "23 parcelas" },
  { value: 24, label: "24 parcelas" }
];

export const PAYMENT_METHODS = [
  { value: "credit_card", label: "Cartão de crédito" },
  { value: "boleto", label: "Boleto" }
];
